import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import toast from "react-hot-toast";
import axios from "axios";
import { MAIN_URL } from "../../../Configurations/Urls";
import AuthShell from "../../../Components/Auth/AuthShell";

function ResetPassword({
  title = "Reset Password",
  appName = "HR ERP Core",
  description,
}) {
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const navigate = useNavigate();

  const location = useLocation();
  const email = location.state?.email;

  useEffect(() => {
    if (!email) {
      toast.error("Invalid access. Please verify OTP again.");
      navigate("/forgot-password");
    }
  }, [email]);

  const [errors, setErrors] = useState({});

  const validateForm = () => {
    let formErrors = {};
    let isValid = true;

    if (!newPassword || newPassword?.length < 6) {
      formErrors.newPassword = "Password must be at least 6 characters.";
      isValid = false;
    }

    if (newPassword !== confirmNewPassword) {
      formErrors.confirmNewPassword = "Passwords do not match.";
      isValid = false;
    }

    setErrors(formErrors);
    return isValid;
  };

  const handleReset = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    try {
      const res = await axios.post(`${MAIN_URL}/api/auth/reset-password`, {
        email,
        new_password: newPassword,
      });
  
      toast.success(res.data.message || "Password reset successful!");
      navigate("/login");
    } catch (error) {
      toast.error(
        error.response?.data?.message || "Failed to reset password."
      );
    }

  };

  return (
    <AuthShell
      title={title}
      subtitle="Choose a new password for your CORE account."
      appName={appName}
      description={description}
    >
      <form onSubmit={handleReset} noValidate>
        <div className="ems-auth-field">
          <label htmlFor="reset-pw">New Password</label>
          <input
            id="reset-pw"
            placeholder="Enter new password"
            type="password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            className="ems-fm-input"
          />
          {errors.newPassword && <span className="ems-fm-err">{errors.newPassword}</span>}
        </div>
        <div className="ems-auth-field">
          <label htmlFor="reset-pw2">Confirm Password</label>
          <input
            id="reset-pw2"
            placeholder="Confirm new password"
            type="password"
            value={confirmNewPassword}
            onChange={(e) => setConfirmNewPassword(e.target.value)}
            className="ems-fm-input"
          />
          {errors.confirmNewPassword && (
            <span className="ems-fm-err">{errors.confirmNewPassword}</span>
          )}
        </div>
        <div className="ems-auth-actions">
          <button type="submit" className="ems-btn ems-primary">
            Reset Password
          </button>
        </div>
      </form>
    </AuthShell>
  );
}

export default ResetPassword;
